import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { store } from '..'
import { Config, IISMethods } from 'config/IISMethods'
import { clearData, setLoading, setProps } from 'redux/actions'
import useService from 'hooks/useService'
import UnlockDoorView from 'view/Unlockdoor/UnlockDoorView'
import { getServerTime } from 'hooks/serverTimeUtils';
import { useSocket, useSocketListener } from "hooks/useSocket"
import { useNavigate } from 'react-router-dom'
import SuccessOverlay from 'view/Components/SuccessOverlay'
import useCongnito from 'hooks/useCongnito'

var Timer = null;
var cardClick = false

const UnLockController = (props) => {
    // const location = useLocation()
    const { socketEmit } = useSocket()
    const { API_Call } = useCongnito()
    const { getStorageData, getURLData, addLoaders, handleGrid, hasExactlyOneLengthOne, setAllStorageData, removeRoomData, getCheckInTime, isblacklistCheck } = useService()
    // const { handledeleteonetimekey, getQueryObj } = useService()
    const getCurrentState = () => store.getState()
    const history = useNavigate()
    const [loadingCardId, setLoadingCardId] = useState(false);
    const [loader, setLoader] = useState(false)
    const [success, setSuccess] = useState('');
    const [latlong, setLetLong] = useState({})
    const [visible, setVisible] = useState(null);
    const [pendingRedirect, setPendingRedirect] = useState(false);
    const [multiRoom, setMultiRoom] = useState([])
    const [lockdata, setLockdata] = useState('')
    // Your existing useEffect
    useEffect(() => {
        (async () => {
            window.addEventListener('visibilitychange', async () => {
                if (document.visibilityState === 'visible' && getCurrentState().loadings.linkdata !== 1 && ['uat', 'prod'].includes(Config.getServermode())) {
                    await getLinkDetails()
                    const DigitalkeyData = getStorageData('digitalkeydata') || {};
                    const { subdomainname } = DigitalkeyData;
                    const dummyid = Config.dummyid;
                    const subscribeIfValid = (id) => {
                        if (id && id !== dummyid) {
                            socketEmit('subscribe', `${subdomainname}${id}`);
                        }
                    };
                    [
                        { data: getStorageData('reservationdata') || [], key: '_id' },
                        { data: getStorageData('onetimekeydata') || [], key: 'roomnoid' },
                        { data: getStorageData('areadashboarddata') || [], key: 'areaid' },
                    ].forEach(({ data, key }) => {
                        data.forEach(item => subscribeIfValid(item[key]));
                    });

                    // handle single area dashboard subscription
                    subscribeIfValid('areakeydashboard');
                }
            })
            navigator.geolocation.getCurrentPosition((position) => {
                let latitude = position.coords.latitude;
                let longitude = position.coords.longitude;
                setLetLong({ "latitude": latitude || '', "longitude": longitude || '' })
            })
            await props.setProps({
                fieldOrder: [],
                newFieldOrder: [],
                nextpage: 0,
                pageNo: 1,
                pagelimit: 20,
                pageName: '',
                formName: '',
                sortData: {},
                formData: {},
                filterData: {},
                oldFilterData: {},
                modal: {},
                masterData: {},
                masterDataList: {}
            });
            let digitalkeydata = IISMethods.getLocalData('DigitalkeyData')
            const key = getURLData().defaultURL;
            if (
                digitalkeydata?.[key] === undefined ||
                (typeof digitalkeydata[key] === 'object' && Object.keys(digitalkeydata[key]).length === 0)
            ) {
                history(`/${getURLData().defaultURL}/linkexpired`)
            }

            await props.clearData();
            await setLinkData()
            // Socket subscriptions
            const DigitalkeyData = getStorageData('digitalkeydata') || {};
            const { subdomainname } = DigitalkeyData;
            const dummyid = Config.dummyid;

            const subscribeIfValid = (id) => {
                if (id && id !== dummyid) {
                    socketEmit('subscribe', `${subdomainname}${id}`);
                }
            };

            // handle array-based subscriptions
            [
                { data: getStorageData('reservationdata') || [], key: '_id' },
                { data: getStorageData('onetimekeydata') || [], key: 'roomnoid' },
                { data: getStorageData('areadashboarddata') || [], key: 'areaid' },
            ].forEach(({ data, key }) => {
                data.forEach(item => subscribeIfValid(item[key]));
            });

            // handle single area dashboard subscription
            subscribeIfValid('areakeydashboard');

            const formData = getCurrentState().formData;
            formData.phonenocountryid = Config.countryid;
            formData.phoneno = '';
            formData.phonenocountryname = Config.countryname;
            formData.phonenocountrycode = Config.codecontact;
            if (getStorageData('isStatusUpdated') === 0 || DigitalkeyData?.sendlink === 1) await UpdateStatus();
        })()
    }, []);

    useEffect(() => {
        (async () => {
            const MAX_TIMEOUT = 2147483647; // ~24.8 days

            let ReservationLengthcheck = getCurrentState().linkData?.ReservationData?.length === 1;

            if (ReservationLengthcheck) {
                let expiretime = getCurrentState().linkData?.ReservationData[0]?.keyexpiretime ||
                    getCurrentState().linkData.PropertyData?.timing?.keyexpirytime;
                let checkout = getCurrentState().linkData?.ReservationData[0]?.checkoutdate;

                if (expiretime && checkout) {
                    let serverTime = await getServerTime({ socketEmit, getStorageData, IISMethods });
                    let currentTime = serverTime;
                    let keyexpireTime = IISMethods.GetDTfromISO(expiretime);
                    let checkoutTime = IISMethods.GetDTfromISO(checkout);

                    keyexpireTime.setDate(checkoutTime.getDate());
                    keyexpireTime.setMonth(checkoutTime.getMonth());
                    keyexpireTime.setFullYear(checkoutTime.getFullYear());

                    let dateTimeDiff = keyexpireTime.getTime() - currentTime.getTime();

                    if (dateTimeDiff > 0) {
                        setVisible(true);

                        // Cap the timeout at MAX_TIMEOUT
                        const delay = Math.min(dateTimeDiff, MAX_TIMEOUT);

                        Timer = setTimeout(() => {
                            console.log('Timer finished after delay:', delay);
                            Timer = clearTimeout(Timer);

                            // If the actual expiry is beyond MAX_TIMEOUT, re-check
                            if (dateTimeDiff > MAX_TIMEOUT) {
                                // Force re-evaluation of the effect
                                setVisible(null);
                                setTimeout(() => setVisible(true), 100);
                            } else {
                                setVisible(false);
                            }
                        }, delay);
                    } else {
                        setVisible(false);
                    }
                }
            } else {
                // Your multi-reservation logic with the same fix
                const linkData = getCurrentState().linkData;
                const ReservationData = linkData?.ReservationData || [];

                if (!Array.isArray(ReservationData) || ReservationData.length === 0) {
                    setVisible(false);
                    return;
                }

                let serverTime = await getServerTime({ socketEmit, getStorageData, IISMethods });
                let currentTime = serverTime;
                let hasValidReservation = false;
                let earliestExpiry = null;

                for (let reservation of ReservationData) {
                    if (reservation.ischeckout === 1) continue;

                    let expiretime = reservation?.keyexpiretime || linkData.PropertyData?.timing?.keyexpirytime;
                    let checkout = reservation?.checkoutdate;

                    if (expiretime && checkout) {
                        let keyexpireTime = IISMethods.GetDTfromISO(expiretime);
                        let checkoutTime = IISMethods.GetDTfromISO(checkout);

                        keyexpireTime.setDate(checkoutTime.getDate());
                        keyexpireTime.setMonth(checkoutTime.getMonth());
                        keyexpireTime.setFullYear(checkoutTime.getFullYear());

                        let dateTimeDiff = keyexpireTime.getTime() - currentTime.getTime();

                        if (dateTimeDiff > 0) {
                            hasValidReservation = true;
                            if (!earliestExpiry || keyexpireTime.getTime() < earliestExpiry) {
                                earliestExpiry = keyexpireTime.getTime();
                            }
                        }
                    }
                }

                if (hasValidReservation && earliestExpiry) {
                    setVisible(true);
                    let timeUntilEarliestExpiry = earliestExpiry - currentTime.getTime();

                    // Cap the timeout at MAX_TIMEOUT
                    const delay = Math.min(timeUntilEarliestExpiry, MAX_TIMEOUT);

                    Timer = setTimeout(() => {
                        console.log('Timer finished - rechecking reservations');
                        Timer = clearTimeout(Timer);

                        // If actual expiry is beyond MAX_TIMEOUT, re-check
                        if (timeUntilEarliestExpiry > MAX_TIMEOUT) {
                            setVisible(null);
                            setTimeout(() => setVisible(true), 100);
                        } else {
                            setVisible(null);
                            setTimeout(() => setVisible(false), 100);
                        }
                    }, delay);
                } else {
                    setVisible(false);
                }
            }
        })();

        return () => Timer = clearTimeout(Timer);
    }, [getCurrentState().linkData]);

    const LinkData = getCurrentState().linkData

    const setLinkData = async () => {
        let keyMappings = {
            DigitalkeyData: 'digitalkeydata',
            PropertyData: 'propertydata',
            ReservationData: 'reservationdata',
            ArealockData: 'arealockdata',
            OnetimekeyData: 'onetimekeydata',
            RoomlockData: 'roomlockdata',
            AreaDashboardData: 'areadashboarddata'
        };
        let storageData = Object.entries(keyMappings).reduce((data, [key, storageKey]) => {
            data[key] = getStorageData(storageKey) || {};
            return data;
        }, {});
        getCurrentState().linkData = storageData
        await props.setProps({ linkData: IISMethods.getCopy(getCurrentState().linkData) })
    }

    // Update status for open link 
    const UpdateStatus = async () => {
        let url = Config.Lambda_weburl + 'linkstatus/update'
        let payload = { shortid: getURLData().defaultURL }

        let { Result } = await API_Call('p', url, payload, {})
        let Status = Result.status

        if (Status === 200) {
            const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
            for (const key of keys) {
                await setAllStorageData('isStatusUpdated', 1, key);
            }
        }
        else { }
    }

    const getLinkDetails = async () => {
        await addLoaders('linkdata', 1)
        let url = Config.Lambda_weburl + 'getlinkdetails'

        let payload = { shortid: getURLData().defaultURL }

        let { Result } = await API_Call('p', url, payload, {})
        let Status = Result.status
        let ResultData = Result.data

        if (Status === 200) {
            let isblacklist = ResultData.reservationdata?.some(res =>
                res?.keyaccessguestdetails?.some(guest =>
                    `+${guest.countrycode}${guest.phoneno}` === ResultData.digitalkeydata?.fullcontact &&
                    guest?.isblacklist === 1
                )
            );
            if (isblacklist) {
                // Add isblacklist: 1 to each group in roomlockdata
                ResultData.roomlockdata = ResultData.roomlockdata?.map(group => ({
                    ...group,
                    isblacklist: 1
                }));

                // Add isblacklist: 1 to each group in arealockdata
                ResultData.arealockdata = ResultData.arealockdata?.map(group => ({
                    ...group,
                    isblacklist: 1
                }));

            }
            // setStorageData('arealockdata', ResultData?.arealockdata)
            getCurrentState().linkData.ReservationData = ResultData?.reservationdata
            getCurrentState().linkData.DigitalkeyData = ResultData?.digitalkeydata
            getCurrentState().linkData.OnetimekeyData = ResultData?.onetimekeydata
            getCurrentState().linkData.RoomlockData = ResultData?.roomlockdata
            getCurrentState().linkData.AreaDashboardData = ResultData?.areadashboarddata
            getCurrentState().linkData.PropertyData = ResultData?.propertydata
            getCurrentState().linkData.ArealockData = ResultData?.arealockdata
            await props.setProps({ linkData: IISMethods.getCopy(getCurrentState().linkData) })
            let storageKeys = ['arealockdata', 'reservationdata', 'digitalkeydata', 'onetimekeydata', 'roomlockdata', 'areadashboarddata', 'propertydata']
            storageKeys.forEach(async key => {
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                for (const data of keys) {
                    await setAllStorageData(key, ResultData[key], data);
                }
            })
        }
        await addLoaders('linkdata', 0)
    }

    const getGuestStatus = (reservationdata) => {
        const systemDate = IISMethods.GetISOdate(LinkData.PropertyData?.systemdate, 1);
        const checkoutdate = IISMethods.GetISOdate(reservationdata?.checkoutdate, 1);
        if (reservationdata?.ischeckin === 1 && reservationdata?.ischeckout === 0 && systemDate !== checkoutdate) {
            return 'In House'
        }
        else if (reservationdata?.ischeckin === 1 && reservationdata?.ischeckout === 0 && systemDate === checkoutdate) {
            return 'Departing'
        }
        else if (reservationdata?.ischeckout === 1) {
            return 'Checked Out'
        }
        else if (reservationdata?.ischeckin === 0 && reservationdata?.ischeckout === 0 && reservationdata?.noshow === 0 && reservationdata?.iscancel === 0) {
            return 'Arriving'
        }
    }

    // Function to get status background color
    const getStatusColor = (status) => {
        switch (status) {
            case 'In House':
                return '#4CAF50'; // Green
            case 'Departing':
                return '#FF9800'; // blue#FF9800
            case 'Checked Out':
                return '#F44336'; // Red
            case 'Arriving':
                return '#2196F3'; // Orange
            default:
                return '#9E9E9E'; // Gray (default)
        }
    }

    // share link | SG 🍕🍔~ 2025-09-17 ~ 11:11 AM
    const CoudeSend = async () => {
        setLoader(1)
        let ReservationLengthcheck = getCurrentState().linkData?.ReservationData?.length === 1
        let guestDetails = LinkData?.DigitalkeyData?.reservationid !== Config.dummyid ? ReservationLengthcheck && LinkData?.ReservationData[0]?.keyaccessguestdetails?.find(guest =>
            `+${guest.countrycode}${guest.phoneno}` === LinkData?.DigitalkeyData?.fullcontact
        ) : LinkData?.DigitalkeyData?.areaid !== Config.dummyid ? LinkData?.AreaDashboardData : LinkData?.OnetimekeyData;
        let firstName = guestDetails?.firstname || ''
        let lastName = guestDetails?.lastname || ''
        let senderfullcontact = `+${guestDetails?.countrycode}${guestDetails?.phoneno}`
        const url = Config.Lambda_weburl + 'verificationcode/send'
        const payload = {
            "type": 3,
            ...(guestDetails?.reservationid === Config.dummyid ? {
                'areaid': LinkData.DigitalkeyData?.areaid || Config.dummyid,
                '_id': LinkData.DigitalkeyData?.timingid || Config.dummyid,
            } : {
                // "reservationid": LinkData.DigitalkeyData?.reservationid || Config.dummyid,
                // "reservationid": multiRoom?.length ? multiRoom?.map(r => r._id) : LinkData.DigitalkeyData?.reservationid ? [LinkData.DigitalkeyData?.reservationid] : [Config.dummyid],
                "reservationid": multiRoom?.length ? multiRoom?.map(r => r._id) : getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length === 1 ? [getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.[0]?.['_id']] : LinkData.DigitalkeyData?.reservationid ? [LinkData.DigitalkeyData?.reservationid] : [Config.dummyid],
            }),
            "firstname": firstName,
            "lastname": lastName,
            "senderfullcontact": senderfullcontact,
            "phoneno": getCurrentState().formData.phoneno,
            "countrycode": getCurrentState().formData.phonenocountrycode,
            "countryname": getCurrentState().formData.phonenocountryname,
            "countryid": getCurrentState().formData.phonenocountryid,
            "fullcontact": '+' + getCurrentState().formData.phonenocountrycode + getCurrentState().formData.phoneno || '',
            "propertyid": LinkData.DigitalkeyData?.propertyid || '',
        }
        let { Result } = await API_Call('p', url, payload, {})
        if (Result.status === 200) {
            setSuccess(Result.message)
            handleGrid(0, 'modal', 'sharekey', false)
            setMultiRoom([])
            getCurrentState().formData.phoneno = '';
            setProps({ formData: IISMethods.getCopy(getCurrentState().formData) })
        }
        else {
            handleGrid(0, 'modal', 'sharekey', false)
            handleGrid({ message: Result.message, title: Result?.title || 'Sorry !' }, 'modal', 'errormodal', true)
        }
        setLoader(0)
    }

    const handleFormData = async (type, key, value) => {
        if (type === 'input-text') {
            getCurrentState().formData[key] = value
        }
        else if (type === 'intl-flagchange') {//intltelinput intl-flagchange
            getCurrentState().formData[key + 'countryid'] = value.iso2
            getCurrentState().formData[key + 'countryname'] = value.name.split(' ')[0]
            getCurrentState().formData[key + 'countrycode'] = value.dialCode
        }
        else {
            getCurrentState().formData[key] = value
        }

        await props.setProps({ formData: IISMethods.getCopy(getCurrentState().formData) })
    }

    // unlocking door Api| SG 🍕🍔~ 2025-09-17 ~ 11:12 AM
    const handleCardClick = async (card) => {
        setLockdata(card?.title)
        // let ReservationLengthcheck = getCurrentState().linkData?.ReservationData?.length === 1
        let reservationdata = IISMethods.getobjectfromarray(getCurrentState().linkData?.ReservationData, 'roomnoid', card.roomorareaid)
        cardClick = true
        let guestDetails = reservationdata?._id !== Config.dummyid ? reservationdata?.keyaccessguestdetails?.find(guest =>
            `+${guest.countrycode}${guest.phoneno}` === LinkData?.DigitalkeyData?.fullcontact
        ) : LinkData?.DigitalkeyData?.areaid !== Config.dummyid ? LinkData?.AreaDashboardData : LinkData?.OnetimekeyData;
        let firstName = guestDetails?.firstname || ''
        let lastName = guestDetails?.lastname || ''
        let senderfullcontact = LinkData?.DigitalkeyData?.isonetimekey ? guestDetails?.phoneno : `+${guestDetails?.countrycode}${guestDetails?.phoneno}`
        setLoadingCardId(true)
        const url = Config.Lambda_weburl + 'unlock'
        const payload = {
            reqlatitude: latlong.latitude || '',
            reqlongitude: latlong.longitude || '',
            isonetimekey: (card?.isonetimekey || LinkData?.DigitalkeyData?.isonetimekey) ? 1 : 0,
            isroomorarea: Number(card?.isroomorarea) || 0,
            roomorareaid: card?.roomorareaid || '',
            propertyid: LinkData.DigitalkeyData?.propertyid || '',
            reservationid: reservationdata?._id,
            phoneno: LinkData?.DigitalkeyData?.fullcontact || '',
            firstname: firstName,
            lastname: lastName,
            senderfullcontact: senderfullcontact,
            ...(Number(card?.isroomorarea) === 1 && { lockids: card.lockid })
            // lockmacno: qrCode || '',
        };

        // !['dev'].includes(Config.getServermode()) ? { timeout: 25 * 1000, timeoutErrorMessage: Config.ErrorMessages['requesttimeout'].message } : {}
        let { Result } = await API_Call('p', url, payload, {})

        if (Result.status === 200) {
            setLoadingCardId(false);
            setSuccess(`${card.title} ${Result.message}`);
            const newData = LinkData?.RoomlockData || [];
            const areaData = LinkData?.ArealockData || [];
            const allData = [...newData, ...areaData];
            const allLockData = allData.flatMap(item => item.lockdata || []);
            const hasRoom = allLockData.some(lock => lock.isroomorarea === 0);
            const hasArea = allLockData.some(lock => lock.isroomorarea === 1);
            const isOneTimeKey = LinkData.DigitalkeyData?.isonetimekey === 1 || card.isonetimekey
            const updatedRoomLockData = newData.map(group => {
                if (group.groupid === card.roomorareaid) {
                    return {
                        ...group,
                        lockdata: group.lockdata.filter(lock => !(lock.roomorareaid === card.roomorareaid && lock.isonetimekey))
                    };
                }
                return group;
            }).filter(group => group.lockdata.length > 0); // remove empty groups too
            const allLocks = updatedRoomLockData.flatMap(group => group.lockdata);
            const allAreNonOneTime = allLocks.every(lock => !lock.isonetimekey);
            if (hasRoom && hasArea) {
                if (isOneTimeKey && card.isroomorarea === 0) {
                    if (!updatedRoomLockData?.length && allAreNonOneTime) {
                        setPendingRedirect(true);
                    } else {
                        await removeRoomData(card.roomorareaid)
                    }
                }
            } else if (isOneTimeKey) {
                if (!updatedRoomLockData?.length && allAreNonOneTime) {
                    setPendingRedirect(true);
                } else {
                    await removeRoomData(card.roomorareaid)
                }
            }
        }
        else {
            handleGrid({ message: Result.message }, 'modal', 'errormodal', 1)
            setLoadingCardId(false);
        }
    }

    //Reservation data updating socket
    useSocketListener('guestexperience', async (data) => {
        const currentReservations = getCurrentState().linkData?.ReservationData || [];
        const roomnoid = data?.roomnoid;
        let Roomdata = getCurrentState().linkData?.RoomlockData || [];
        const index = currentReservations.findIndex(res => res._id === data._id);
        if (data?.iscancel === 1 || data?.noshow === 1) {
            let matchid = roomnoid === Roomdata[0]?.groupid;
            if (!getCurrentState().linkData?.AreaDashboardData?.length && !getCurrentState().linkData?.OnetimekeyData?.length && Roomdata.length === 1 && matchid) {
                handleGrid(Config.ErrorMessages['reservationnotfound'], 'modal', 'errormodal', 1);
                history(`/${getURLData().defaultURL}/linkexpired`);
            } else {
                await removeRoomData(roomnoid)
            }
        } else {
            if (index !== -1) {
                currentReservations[index] = { ...currentReservations[index], ...data };
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                for (const key of keys) {
                    await setAllStorageData('reservationdata', currentReservations, key);
                }
                // setAllStorageData('reservationdata', currentReservations , 'reservationdata');
                getCurrentState().linkData.ReservationData = currentReservations;
                await props.setProps({ linkData: IISMethods.getCopy(getCurrentState().linkData) });
            }
            let fullContact = getCurrentState().linkData.DigitalkeyData?.fullcontact;
            let guestDetails = getCurrentState().linkData.ReservationData[index]?.keyaccessguestdetails?.find(guest =>
                `+${guest.countrycode}${guest.phoneno}` === fullContact
            );
            if (guestDetails?.isblacklist === 1) {
                const linkData = getCurrentState().linkData || {};
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];

                // Map Redux key → lowercase storage key
                const dataMap = {
                    RoomlockData: 'roomlockdata',
                    ArealockData: 'arealockdata'
                };

                for (const reduxKey in dataMap) {
                    const storageKey = dataMap[reduxKey];

                    // Add isblacklist flag to top-level groups
                    linkData[reduxKey] = (linkData[reduxKey] || []).map(group => ({
                        ...group,
                        isblacklist: 1
                    }));

                    // Save to storage for all keys
                    for (const key of keys) {
                        await setAllStorageData(storageKey, linkData[reduxKey], key);
                    }
                }

                // Update Redux state
                await props.setProps({ linkData: IISMethods.getCopy(linkData) });
            } else {
                const linkData = getCurrentState().linkData || {};
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                const dataMap = {
                    RoomlockData: 'roomlockdata',
                    ArealockData: 'arealockdata'
                };

                let shouldUpdate = false;

                if (getCurrentState().linkData?.RoomlockData?.some(group => group.isblacklist === 1)) {
                    for (const reduxKey in dataMap) {
                        const storageKey = dataMap[reduxKey];

                        shouldUpdate = true;

                        // Remove the isblacklist flag
                        linkData[reduxKey] = linkData[reduxKey].map(({ isblacklist, ...rest }) => rest);

                        // Update storage for all keys
                        for (const key of keys) {
                            await setAllStorageData(storageKey, linkData[reduxKey], key);
                        }

                    }
                    await getLinkDetails();
                }

                // Update Redux state only if any changes were made
                if (shouldUpdate) {
                    await props.setProps({ linkData: IISMethods.getCopy(linkData) });
                }
            }
        }
    });

    //One time key data updating socket
    useSocketListener('onetimekey', async (data) => {
        let newdata = IISMethods.getobjectfromarray(getCurrentState().linkData?.OnetimekeyData, '_id', data._id)
        const updatedRoomLockData = getCurrentState().linkData?.RoomlockData.map(group => {
            if (group.groupid === newdata?.roomnoid) {
                return {
                    ...group,
                    lockdata: group.lockdata.filter(lock => !(lock.roomorareaid === newdata?.roomnoid && lock.isonetimekey))
                };
            }
            return group;
        }).filter(group => group.lockdata.length > 0); // remove empty groups too
        const allLocks = updatedRoomLockData.flatMap(group => group.lockdata);
        const allAreNonOneTime = allLocks.every(lock => !lock.isonetimekey);
        if (!cardClick) {
            if (!updatedRoomLockData?.length && allAreNonOneTime) {
                history(`/${getURLData().defaultURL}/linkexpired`);
                handleGrid(Config.ErrorMessages['linkexpired'], 'modal', 'errormodal', 1)
            } else {
                await removeRoomData(newdata?.roomnoid)
            }
        }
    });

    // Area data updating socket
    useSocketListener('areakeydashboard', async (data) => {
        const DigitalkeyData = getCurrentState().linkData?.DigitalkeyData;
        if (DigitalkeyData?.areaid && !DigitalkeyData?.isonetimekey && DigitalkeyData?.areaid === data?.areaid) {
            let obj = IISMethods.getobjectfromarray(data?.digitalkeydata, '_id', DigitalkeyData?.timingid);
            if (obj) {
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                for (const key of keys) {
                    await setAllStorageData('areadashboarddata', obj, key);
                }
                getCurrentState().linkData.AreaDashboardData = { ...getCurrentState().linkData.AreaDashboardData, ...obj }
                await props.setProps({ linkData: IISMethods.getCopy(getCurrentState().linkData) })
            }
            else {
                handleGrid(Config.ErrorMessages['reservationnotfound'], 'modal', 'errormodal', 1)
                history(`/${getURLData().defaultURL}/linkexpired`);
            }
        } else {
            let obj = IISMethods.getobjectfromarray(data?.digitalkeydata, 'reservationid', DigitalkeyData?.reservationid);
            if (obj?.isblacklist === 1) {
                const linkData = getCurrentState().linkData || {};
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                const dataMap = {
                    RoomlockData: 'roomlockdata',
                    ArealockData: 'arealockdata'
                };

                for (const reduxKey in dataMap) {
                    const storageKey = dataMap[reduxKey];

                    // Add isblacklist flag to top-level groups
                    linkData[reduxKey] = (linkData[reduxKey] || []).map(group => ({
                        ...group,
                        isblacklist: 1
                    }));

                    // Save to storage for all keys
                    for (const key of keys) {
                        await setAllStorageData(storageKey, linkData[reduxKey], key);
                    }
                }

                // Update Redux state
                await props.setProps({ linkData: IISMethods.getCopy(linkData) });
            } else {
                const linkData = getCurrentState().linkData || {};
                const keys = ['reservationdata', 'onetimekeydata', 'areadashboarddata'];
                const dataMap = {
                    RoomlockData: 'roomlockdata',
                    ArealockData: 'arealockdata'
                };

                let shouldUpdate = false;

                if (getCurrentState().linkData?.RoomlockData?.some(group => group.isblacklist === 1)) {
                    for (const reduxKey in dataMap) {
                        const storageKey = dataMap[reduxKey];

                        shouldUpdate = true;

                        // Remove the isblacklist flag
                        linkData[reduxKey] = linkData[reduxKey].map(({ isblacklist, ...rest }) => rest);

                        // Update storage for all keys
                        for (const key of keys) {
                            await setAllStorageData(storageKey, linkData[reduxKey], key);
                        }

                    }
                    await getLinkDetails();
                }

                // Update Redux state only if any changes were made
                if (shouldUpdate) {
                    await props.setProps({ linkData: IISMethods.getCopy(linkData) });
                }
            }
        }
    });

    // Audit run socket to remove block
    useSocketListener('digitalkeycheckout', async (data) => {
        const roomnoid = data?.roomnoid;
        let Roomdata = getCurrentState().linkData?.RoomlockData || [];
        let matchid = roomnoid === Roomdata[0]?.groupid;
        if (!getCurrentState().linkData?.AreaDashboardData?.length && !getCurrentState().linkData?.OnetimekeyData?.length && Roomdata.length === 1 && matchid) {
            handleGrid(Config.ErrorMessages['reservationnotfound'], 'modal', 'errormodal', 1);
            history(`/${getURLData().defaultURL}/linkexpired`);
        } else {
            await removeRoomData(roomnoid)
        }
    });

    return (
        <>
            <UnlockDoorView
                getGuestStatus={getGuestStatus}
                getStatusColor={getStatusColor}
                handleCardClick={handleCardClick}
                handleFormData={handleFormData}
                CoudeSend={CoudeSend}
                handleGrid={handleGrid}
                loader={loader}
                loadingCardId={loadingCardId}
                visible={visible}
                setVisible={setVisible}
                success={success}
                setSuccess={setSuccess}
                LinkData={LinkData}
                getServerTime={getServerTime}
                setMultiRoom={setMultiRoom}
                multiRoom={multiRoom}
                hasExactlyOneLengthOne={hasExactlyOneLengthOne}
                getURLData={getURLData}
                setLockdata={setLockdata}
                lockdata={lockdata}
                getCheckInTime={getCheckInTime}
                isblacklistCheck={isblacklistCheck}
            />
            <SuccessOverlay
                show={success}
                message={success}
                onClose={() => {
                    setSuccess('');
                    if (pendingRedirect) {
                        handleGrid(Config.ErrorMessages['linkexpired'], 'modal', 'errormodal', 1);
                        history(`/${getURLData().defaultURL}/linkexpired`);
                    }
                }}
            />
        </>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    clearData: (payload) => dispatch(clearData(payload)),
    setProps: (payload) => dispatch(setProps(payload)),
    setLoading: (payload) => dispatch(setLoading(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UnLockController)